import type { FunctionComponent } from 'react';

import Footer from './Footer';

export default Footer as FunctionComponent;
